// @flow

import styled from 'styled-components';

import { WORK_AREA_WIDTH } from '../../../constants';

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: ${WORK_AREA_WIDTH}px;
  background-color: ${props => props.theme.clockInBg};
`;
